import qs from 'query-string';

import getEnvConfig from 'utils/config/env';

import { AnalyticsQueryExport, TFilters } from '../services/interfaces';

export const downloadContentAnalytics = async (
    filters: TFilters,
    type: AnalyticsQueryExport
) => {
    const token = localStorage.getItem('accessToken');
    const baseURL = new URL(getEnvConfig().env.API_URL);
    let url = '';
    const query = qs.stringify(
        {
            period: filters.period,
            date_from: filters.date_from,
            date_to: filters.date_to,
        },
        { skipNull: true, arrayFormat: 'colon-list-separator' }
    );

    switch (type) {
        case 'readers': {
            url = `${baseURL}/content/analytics/readers/export?${query}`;
            break;
        }
        case 'webinars': {
            url = `${baseURL}/webinars/export?${query}`;
            break;
        }
        case 'posts': {
            url = `${baseURL}/statistic/publication-export?${query}`;
            break;
        }
        default: {
            throw new Error('Not implemented');
        }
    }

    const data = await fetch(url, {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
    const response = await data.json();
    window.open(
        `${getEnvConfig().env.API_URL.replace(/api\/v3/, '')}/${
            response.file_path || response.data.file_path
        }`
    );
};
